// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
// import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { MyRouterContext } from '../api/auth'
import { StoreProvider } from '@/stores/rootStore'

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <StoreProvider>
      <Outlet />
      {/* <TanStackRouterDevtools />
      <ReactQueryDevtools initialIsOpen={false} /> */}
    </StoreProvider>
  ),
})

export const RootRoute = Route
